import Vue from 'vue'
import App from './App.vue'
import router from './router'
import store from './store'
import vuetify from './plugins/vuetify'
import './filters/filters'
import './directives/directives'
import StringConst from './plugins/sharedStrings'

Vue.config.productionTip = false

new Vue({
  router,
  store,
  vuetify,
  render: h => h(App)
}).$mount('#app')

Vue.use(StringConst)
Vue.filter
Vue.directive
